var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.667 2a9.667 9.667 0 1 0 6.726 16.61 1 1 0 0 1 .217-.217 9.64 9.64 0 0 0 2.723-6.726c0-5.34-4.328-9.667-9.666-9.667m8.926 17.179a11.62 11.62 0 0 0 2.74-7.512C23.333 5.223 18.11 0 11.667 0S0 5.223 0 11.667c0 6.443 5.223 11.666 11.667 11.666a11.62 11.62 0 0 0 7.512-2.74l5.114 5.114a1 1 0 0 0 1.414-1.414z",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;